export class DEBUG {
    Type: string = "DEBUG";
    SerialNumber: string;
    DeviceId: string;
    Date: Date;
    Message: string;
}